export default {
  setClearModuleCacheEnabled(state, clearModuleCacheEnabled) {
    state.clearModuleCacheEnabled = clearModuleCacheEnabled;
  },
  setCeEnvironment(state, ceEnvironment) {
    state.ceEnvironment = ceEnvironment;
  }
};
